import { useIntl } from "react-intl";

export const TabTitle = (newTitle) => {
    const { formatMessage } = useIntl();
    return (document.title = formatMessage({id: `header.title.${newTitle}`,defaultMessage:"Aptor"}));
}